import i18n from '../i18n';

export interface ResetPasswordEmailData {
  fullName?: string;
  username?: string;
  resetLink: string;
}

export interface EmailTemplate {
  subject: string;
  htmlBody: string;
}

/**
 * Service pour générer les templates d'email multilingues
 */
export class EmailTemplateService {
  /**
   * Génère le template d'email pour la réinitialisation du mot de passe
   * @param data - Les données nécessaires pour le template
   * @param language - La langue du template (optionnel, utilise la langue courante par défaut)
   * @returns Le template d'email avec sujet et corps HTML
   */
  static generateResetPasswordTemplate(
    data: ResetPasswordEmailData,
    language?: string
  ): EmailTemplate {
    // Utilise la langue spécifiée ou la langue courante
    const lang = language || i18n.language;
    
    // Récupère les traductions pour la langue spécifiée
    const t = (key: string) => {
      return i18n.getFixedT(lang)(`auth.resetEmailTemplate.${key}`);
    };

    // Remplace les placeholders dans les textes
    const displayName = data.username || 'PLACEHOLDER_USERNAME';
    const greeting = t('greeting').replace('{{username}}', displayName);
    const subject = t('subject');
    const message = t('message');
    const instruction = t('instruction');
    const buttonText = t('buttonText');
    const expiration = t('expiration');
    const ignore = t('ignore');
    const fallbackText = t('fallbackText');

    // Génère le corps HTML de l'email
    const htmlBody = `
      <html>
      <body>
          <h2>${subject}</h2>
          <p>${greeting}</p>
          <p>${message}</p>
          <p>${instruction}</p>
          <p><a href="${data.resetLink}" style="background-color: #007bff; color: white; padding: 10px 20px; text-decoration: none; border-radius: 5px;">${buttonText}</a></p>
          <p>${expiration}</p>
          <p>${ignore}</p>
          <br>
          <p style="color: #666; font-size: 12px;">
              ${fallbackText}<br>
              ${data.resetLink}
          </p>
      </body>
      </html>
    `;

    return {
      subject,
      htmlBody
    };
  }

  /**
   * Génère le template d'email pour la réinitialisation du mot de passe en français
   * @param data - Les données nécessaires pour le template
   * @returns Le template d'email en français
   */
  static generateResetPasswordTemplateFr(data: ResetPasswordEmailData): EmailTemplate {
    return this.generateResetPasswordTemplate(data, 'fr');
  }

  /**
   * Génère le template d'email pour la réinitialisation du mot de passe en anglais
   * @param data - Les données nécessaires pour le template
   * @returns Le template d'email en anglais
   */
  static generateResetPasswordTemplateEn(data: ResetPasswordEmailData): EmailTemplate {
    return this.generateResetPasswordTemplate(data, 'en');
  }
}

export default EmailTemplateService;